export type StickyNoteColor = 'yellow' | 'green' | 'orange' | 'red' | 'blue' | 'pink';

export const STICKY_NOTE_COLORS: StickyNoteColor[] = ['yellow', 'green', 'orange', 'red', 'blue', 'pink'];

export type StickyNote = {
  id: string;
  color: StickyNoteColor;
  text: string;
  x: number;
  y: number;
  width: number;
  height: number;
  zIndex: number;
  minimized: boolean;
  updatedAt: string;
};

export const STICKY_NOTES_MAX = 20;
export const STICKY_NOTE_WIDTH = 200;
export const STICKY_NOTE_MIN_WIDTH = 160;
export const STICKY_NOTE_MAX_WIDTH = 480;
export const STICKY_NOTE_MIN_HEIGHT = 160;
export const STICKY_NOTE_MAX_HEIGHT = 520;
export const STICKY_NOTES_STORAGE_PREFIX = 'stickyNotes';
